import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Button, Typography, Modal, Backdrop, Fade, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function CookieBannerPage() {

    const [searchParams] = useSearchParams();
    
    const redirectUrl = searchParams.get("url") || "https://default.com"; // Default fallback
    const screenshotURL = searchParams.get("img") || "http://api.screenshotlayer.com/api/capture?access_key=1a8c2267023e0232fb186485021d76c0&url=https%3A%2F%2Fwww.smile-therapy.co.uk%2Fproducts%2Fultrasonic-tooth-cleaner%3Fsrsltid%3DAfmBOopV_2Jnlf6_L6xOsXXLJiud5UQARLQDHTf93bGdsE86Vc-mXF4C&width=1440";

    return (
        <Modal
            open={true}
            onClose={() => window.location.href = redirectUrl} // ✅ Redirects user on backdrop click
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                    sx: {
                        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${screenshotURL})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat"
                    }
                }
            }}
        >
            <Fade in={true}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 500,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        padding: 5,
                        borderRadius: 2,
                        textAlign: "center",
                    }}
                >
                    {/* Close Button */}
                    <IconButton
                        onClick={() => window.location.href = redirectUrl} // ✅ Close button also redirects
                        sx={{ position: "absolute", top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
    
                    {/* Title */}
                    <Typography variant="h6" gutterBottom>
                        This website uses cookies to enhance your experience.
                    </Typography>
    
                    {/* Action Buttons */}
                    <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => window.location.href = redirectUrl} // ✅ Redirects on button click
                            sx={{ width: "50%" }}
                        >
                            SAVE & CLOSE
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => window.location.href = redirectUrl} // ✅ Redirects on button click
                            sx={{ width: "50%" }}
                        >
                            DECLINE ALL
                        </Button>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}

export default CookieBannerPage;